export default __webpack_public_path__ + "static/media/Ellipse 197.d7df13ce.svg";